import { useCallback, useEffect, useMemo, useState } from "react";
import { Spinner } from "@ugitgud/legos/ui/misc/Spinner";
import { useAsyncFetch } from "@ugitgud/legos/hooks/useAsyncFetch";

export const ALLSTAR_PUBLIC_API_KEY = "25f05c4b-ebd8-45cb-bd13-7f679a975646";

export const ALLSTAR_AUTH_HEADERS = {
  "X-API-Key": ALLSTAR_PUBLIC_API_KEY,
};

export const AllstarEmbed: React.FC<{
  loading?: JSX.Element;
  error?: JSX.Element;
  path: string;
  width?: number;
  height?: number;
  className?: string;
  layout?: "default" | "nextUp";
}> = ({
  className,
  width = 602,
  height = 393,
  path,
  error: errorFallback = null,
  loading: loadingFallback = <Spinner className="w-[64px] h-[64px]" />,
  layout = "default",
}) => {
  const url = useMemo(() => `https://prt.allstar.gg/${path}`, [path]);
  const { data, loading, error, state } = useAsyncFetch<{ message: string; requestId: string; data: { playlistUrl: string } }>(
    url,
    ALLSTAR_AUTH_HEADERS,
    "GET",
  );
  const [urlParsed, setURLParsed] = useState<string | undefined>();
  useEffect(() => {
    if (data?.data?.playlistUrl) {
      let playlistUrl = data?.data?.playlistUrl;
      if (layout !== "default") {
        playlistUrl = playlistUrl + "&layout=" + layout;
      }

      setURLParsed(playlistUrl);
    }
  }, [data, layout]);
  if (!loading && error) {
    return <>{errorFallback}</>;
  }

  return (
    <div style={{ minHeight: height, minWidth: width, width, height }}>
      {loading && (
        <div className="flex-grow flex items-center justify-center w-full h-full min-w-full min-h-full">{loadingFallback}</div>
      )}
      <div className={className} style={{ minHeight: height, minWidth: width, width, height }}>
        {!loading && urlParsed && <iframe frameBorder={0} allowFullScreen src={urlParsed} width={width} height={height} />}
      </div>
    </div>
  );
};
